import React, { useCallback } from 'react';
import { formatISO } from 'date-fns';
import { useAppSelector } from 'store/hooks';
import { SettingsSection, Spacer, TextButtonLinkSeeAll } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import { formatAmount, formatDateForItem } from 'utils/formatting';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectFirstFiveActivitiesForPot } from '../reducers/selectors';
import AutosaveActivityCardForPot from './AutosaveActivityCardForPot';
import PotActivity from './PotActivity';
const PotsActivitySection = ({ pot, hideSpaceUserAvatar }) => {
    const { navigateDeprecated } = useMainStackNavigation();
    const { slicedData: potsActivities, shouldShowSeeAll } = useAppSelector((state) => selectFirstFiveActivitiesForPot(state, pot.id));
    const handleSeeAll = useCallback(() => {
        navigateDeprecated('PotsActivity', { pot, hideSpaceUserAvatar });
    }, [pot, hideSpaceUserAvatar]);
    if (!potsActivities?.length)
        return null;
    return (<>
      <Spacer h={8}/>
      <SectionHeader horizontalMargins button={shouldShowSeeAll ? <TextButtonLinkSeeAll onPress={handleSeeAll}/> : null}>
        Activity
      </SectionHeader>
      <Spacer.H16 />
      <SettingsSection noMarginTop>
        {potsActivities.map((activity) => {
            if (activity.type === 'AUTO_SAVE') {
                return <AutosaveActivityCardForPot pot={pot} activity={activity} key={activity.id}/>;
            }
            return (<PotActivity eta={activity.eta} key={activity.id} type={activity.type} title={activity.title} emoji={activity.emoji} amount={activity.amount} status={activity.status} timestamp={activity.timestamp} depositEta={activity.depositEta} productId={activity.potProductId} bankName={activity.potPartnerBankName} depositDetails={activity.depositDetails} isBankTransfer={activity.isBankTransfer} forceShowPositiveAmount={activity.amount.value > 0} formattedDate={activity.timestamp ? formatDateForItem(formatISO(activity.timestamp)) : ''} formattedAmount={`${activity.amount.value > 0 ? '+' : ''}${formatAmount(activity.amount.value, activity.amount.currency, 2)}`} pot={pot} hideSpaceUserAvatar={hideSpaceUserAvatar}/>);
        })}
      </SettingsSection>
      <Spacer.H16 />
    </>);
};
export default PotsActivitySection;
